<template>
  <div class="news-widget">
    <!-- Header: same layout/style as AssetSelector -->
    <div
      class="row f-row bdr-l bdr-r w-100"
      style="height: 2.2rem; background: var(--darkbackground2); margin: 0;"
    >
      <!-- Commodities -->
      <div
        class="col col-auto d-flex align-items-center"
        style="z-index: 10000; padding-left: 0.5rem;"
      >
        <MultiSelect
          v-model="selectedCommodities"
          :options="commodityOptions"
          optionLabel="label"
          placeholder="Commodities"
          scrollHeight="200px"
          @change="onCategoriesChanged"
          style="max-width: 140px;"
        >
          <template #value>
            <span v-if="selectedCommodities">
              {{
                selectedCommodities.length == 0
                  ? "Commodities"
                  : selectedCommodities.length == 1
                  ? selectedCommodities[0].label
                  : selectedCommodities.length === commodityOptions.length
                  ? "All Commodities"
                  : selectedCommodities.length + "x Commodities"
              }}
            </span>
            <span v-else>Commodities</span>
          </template>
          <template #option="slotProps">
            <div>{{ slotProps.option.label }}</div>
          </template>
        </MultiSelect>

        <!-- <div
          class="d-flex align-items-center flex-wrap ml-2"
          style="gap: 0.25rem;"
        >
          <span v-if="selectedCommodities.length != commodityOptions.length">
            <span
              v-for="cat in selectedCommodities"
              :key="cat.value"
              class="category-chip"
            >
              {{ cat.label }}
              <span class="chip-close" @click.stop="removeCommodity(cat)"
                >×</span
              >
            </span>
          </span>
          <span v-else>
            <span class="category-chip">
              All
              <span class="chip-close" @click.stop="removeCommodity(undefined)"
                >×</span
              >
            </span>
          </span>
        </div> -->
      </div>

      <!-- Currencies -->
      <div
        class="col col-auto d-flex align-items-center"
        style="z-index: 10000; padding-left: 0.5rem;"
      >
        <MultiSelect
          v-model="selectedCurrencies"
          :options="currencyOptions"
          optionLabel="label"
          placeholder="Currencies"
          scrollHeight="200px"
          @change="onCategoriesChanged"
          style="max-width: 140px;"
        >
          <template #value>
            <span v-if="selectedCurrencies">
              {{
                selectedCurrencies.length == 0
                  ? "Currencies"
                  : selectedCurrencies.length == 1
                  ? "Fx: " + selectedCurrencies[0].label
                  : selectedCurrencies.length === currencyOptions.length
                  ? "All Currencies"
                  : selectedCurrencies.length + "x Currencies"
              }}
            </span>
            <span v-else>Currencies</span>
          </template>
          <template #option="slotProps">
            <div>{{ slotProps.option.label }}</div>
          </template>
        </MultiSelect>

        <!-- <div
          class="d-flex align-items-center flex-wrap ml-2"
          style="gap: 0.25rem;"
        >
          <span v-if="selectedCurrencies.length != currencyOptions.length">
            <span
              v-for="cat in selectedCurrencies"
              :key="cat.value"
              class="category-chip"
            >
              {{ cat.label }}
              <span class="chip-close" @click.stop="removeCurrency(cat)"
                >×</span
              >
            </span>
          </span>
          <span v-else>
            <span class="category-chip">
              All
              <span class="chip-close" @click.stop="removeCurrency(undefined)"
                >×</span
              >
            </span>
          </span>
        </div> -->
      </div>

      <div
        class="col col-cx d-flex align-items-center"
        style="z-index: 10000; padding-left: 0.5rem;"
      >
        <label
          class="ml-2"
          v-bind:class="[showMacro ? 'btn-checkbox-active' : 'btn-checkbox']"
        >
          <input type="checkbox" v-on:click="onClientShowMacro" />
          <span>
            <span class="inh" style="width: 10px!important;" v-if="showMacro">
              &#x2714;
            </span>
            <span class="inh" style="width: 10px!important;" v-else
              >&#x2022;</span
            >
            <span
              style="padding-left: 5px;"
              :style="{
                color: showMacro ? 'var(--textative)' : 'var(--textinactive)',
              }"
              >Macro</span
            >
          </span>
        </label>
        <label
          class="ml-2"
          v-bind:class="[showIndexes ? 'btn-checkbox-active' : 'btn-checkbox']"
        >
          <input type="checkbox" v-on:click="onClientShowIndexes" />
          <span>
            <span class="inh" style="width: 10px!important;" v-if="showIndexes">
              &#x2714;
            </span>
            <span class="inh" style="width: 10px!important;" v-else
              >&#x2022;</span
            >
            <span
              style="padding-left: 5px;"
              :style="{
                color: showIndexes ? 'var(--textative)' : 'var(--textinactive)',
              }"
              >Indexes</span
            >
          </span>
        </label>
        <label
          class="ml-2"
          v-bind:class="[showIntRates ? 'btn-checkbox-active' : 'btn-checkbox']"
        >
          <input type="checkbox" v-on:click="onClientShowIntRates" />
          <span>
            <span
              class="inh"
              style="width: 10px!important;"
              v-if="showIntRates"
            >
              &#x2714;
            </span>
            <span class="inh" style="width: 10px!important;" v-else
              >&#x2022;</span
            >
            <span
              style="padding-left: 5px;"
              :style="{
                color: showIntRates
                  ? 'var(--textative)'
                  : 'var(--textinactive)',
              }"
              >IntRates</span
            >
          </span>
        </label>
        <!-- <label
          class="ml-2"
          v-bind:class="[languajeEn ? 'btn-checkbox-active' : 'btn-checkbox']"
        >
          <input type="checkbox" v-on:click="onClientEn" />
          <span>
            <span class="inh" style="width: 10px!important;" v-if="languajeEn">
              &#x2714;
            </span>
            <span class="inh" style="width: 10px!important;" v-else
              >&#x2022;</span
            >
            <span
              style="padding-left: 5px;"
              :style="{
                color: languajeEn ? 'var(--textative)' : 'var(--textinactive)',
              }"
              >en</span
            >
          </span>
        </label> -->
        <button
          v-if="showFetchButton || isLoading"
          type="button"
          :disabled="!showFetchButton"
          class="btn btn-strat-alert"
          style="margin: 0 0 0 8px!important; width: 50px!important; min-width: 50px!important;"
          v-on:click="onFetchButton"
        >
          <span v-if="isLoading" class="text-center">
            <QSLoading :isLoading="isLoading" :size="20" :colorTheme="true" />
          </span>
          <span v-else>Fetch</span>
        </button>
      </div>

      <div class="col-auto d-flex align-items-center pr-1">
        <ButtonClose
          fontSize="18"
          :showBorder="false"
          @btnAbort="$emit('eventOnUserClearComponent', componentNumber)"
        />
      </div>
    </div>

    <!-- Body -->
    <div class="news-widget-body" ref="newsBody" @scroll="onNewsScroll">
      <span v-if="isLoading" class="news-status-msg text-left mr-2">
        <QSLoading :isLoading="isLoading" :size="40" :colorTheme="colorTheme"
      /></span>
      <div v-else-if="errorMsg" class="news-status-msg text-center">
        {{ errorMsg }}
      </div>
      <div v-else-if="newsList.length === 0" class="news-status-msg">
        No news found for the selected categories.
      </div>
      <div v-else class="news-list">
        <div
          v-for="(item, idx) in newsList"
          :key="idx"
          class="news-card"
          :class="
            getNewsHighlight(item.published_at).type === 'live'
              ? 'live-news'
              : getNewsHighlight(item.published_at).type === 'today'
              ? 'today-news'
              : 'old-news'
          "
          @click="openNews(item)"
        >
          <div class="news-card-img-wrapper">
            <img
              :src="getImage(item, idx)"
              class="news-card-img"
              alt=""
              @error="onImgError($event, idx)"
            />
          </div>
          <div class="news-card-content">
            <p class="news-card-title">
              <span
                v-if="getNewsHighlight(item.published_at)['type'] == 'today'"
              >
                <i class="pi pi-circle-fill live-icon"></i>
              </span>
              <span v-else>
                {{ getNewsHighlight(item.published_at)["icon"] }}
              </span>
              <span class="news-card-source"> {{ item.source }}: </span>
              {{ item.title }}
            </p>
            <div class="news-card-footer">
              <div class="news-card-tags">
                <span
                  v-for="(tag, ti) in getItemTags(item)"
                  :key="ti"
                  class="news-tag-badge"
                  >{{ formatTag(tag) }}</span
                >
              </div>
              <span class="news-time-ago">
                {{ timeAgo(item.published_at) }}
              </span>
              <!-- {{ getNewsHighlight(item.published_at) }} -->
            </div>
          </div>
        </div>
        <div v-if="isLoadingMore" class="news-load-more">
          <QSLoading :isLoading="true" :size="30" :colorTheme="colorTheme" />
        </div>
      </div>
    </div>

    <!-- News Detail Modal -->
    <transition name="news-modal-fade">
      <div
        v-if="selectedNews"
        class="news-modal-overlay"
        @click.self="closeNews"
      >
        <div
          class="news-modal"
          :class="
            getNewsHighlight(selectedNews.published_at).type === 'live'
              ? 'live-news'
              : getNewsHighlight(selectedNews.published_at).type === 'today'
              ? 'today-news'
              : 'old-news'
          "
        >
          <div class="news-modal-header mt-3">
            <h3 class="news-modal-title">{{ selectedNews.title }}</h3>
            <ButtonClose
              fontSize="18"
              :showBorder="false"
              @btnAbort="closeNews"
            />
          </div>

          <div class="news-modal-meta mt-2">
            <div v-if="selectedNews.summary" class="news-modal-summary">
              <p class="news-modal-summary-text news-modal-meta-row">
                <span>
                  <span class="sm-txt">Source:</span>
                  {{ selectedNews.source }}
                </span>
                <span>
                  <span class="sm-txt"
                    >Published:
                    {{ getNewsHighlight(selectedNews.published_at)["icon"] }}
                    {{ getNewsHighlight(selectedNews.published_at)["label"] }}
                  </span>
                  {{ timeAgo(selectedNews.published_at) }}
                </span>
              </p>
              <h5 class="news-modal-summary-label">Summary</h5>
              <p class="news-modal-summary-text">{{ selectedNews.summary }}</p>
            </div>
            <div v-if="getAllTags(selectedNews).length" class="news-modal-tags">
              <span
                v-for="(tag, ti) in getAllTags(selectedNews)"
                :key="ti"
                class="news-tag-badge"
                >{{ formatTag(tag) }}</span
              >
            </div>
          </div>

          <div class="news-modal-iframe-wrapper">
            <!-- <iframe
              v-if="showFullContent.includes(selectedNews.source)"
              :src="selectedNews.url"
              class="news-modal-iframe"
              frameborder="0"
              sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
              referrerpolicy="no-referrer"
            /> -->
            <div class="news-modal-iframe-wrapper">
              <h5 class="news-modal-summary-label">Content</h5>
              <p>
                <a
                  :href="selectedNews.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="news-link"
                >
                  Read full article ↗
                </a>
              </p>
              <div
                v-if="!showFullContent.includes(selectedNews.source)"
                v-html="
                  renderMarkdown(
                    selectedNews.content.slice(0, 500) +
                      ' [+' +
                      (selectedNews.content.length - 500).toLocaleString(
                        'es-CO',
                      ) +
                      ' chars]',
                  )
                "
                class="markdown-body news-modal-content-text"
              ></div>
              <div
                v-else
                v-html="renderMarkdown(selectedNews.content)"
                class="markdown-body news-modal-content-text"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ButtonClose from "@/components/buttons/Close";
import MarkdownIt from "markdown-it";
import MultiSelect from "primevue/multiselect";
import { saveUserPreferences } from "@/_core/data/SaveToDB";
import { getNews } from "@/_core/data/api_calls/getNews";
import {
  COMMODITIES,
  CURRENCIES,
  DEFAULT_COMMODITY,
  DEFAULT_CURRENCY,
  SHOW_FULL_CONTENT,
} from "./constants/newsCategories";
import {
  getAllTags,
  getFallbackImageByCategories,
  getImageForNews,
  getItemTags,
  getNewsHighlight,
  timeAgo,
} from "./helpers/newsHelpers";
import QSLoading from "@/components/QSLoading.vue";

const md = new MarkdownIt({
  breaks: true,
  linkify: true,
});

export default {
  name: "NewsWidget",

  components: {
    ButtonClose,
    MultiSelect,
    QSLoading,
  },

  props: {
    colorTheme: { type: Boolean, default: true },
    componentNumber: { type: Number, default: 1 },
  },

  data() {
    return {
      backgroundErrorMsg: null,
      backgroundNewsBuffer: [],
      commodityOptions: COMMODITIES,
      currencyOptions: CURRENCIES,
      englishOn: true,
      errorMsg: null,
      isBackgroundRefreshing: false,
      isLoading: false,
      isLoadingMore: false,
      // languajeEn: true,
      newsList: [],
      newsOffset: 0,
      newsPollTimer: null,
      newsTotal: 0,
      selectedCommodities: COMMODITIES,
      selectedCurrencies: CURRENCIES,
      selectedNews: null,
      showFetchButton: false,
      showFullContent: SHOW_FULL_CONTENT,
      showIndexes: false,
      showIntRates: false,
      showMacro: false,
    };
  },

  computed: {
    selectedCommodityValues() {
      return this.selectedCommodities.map((c) => c.value);
    },
    selectedCurrencyValues() {
      return this.selectedCurrencies.map((c) => c.value);
    },
  },

  created() {
    this.loadInitialValues();
    this.fetchNews();
  },

  mounted() {
    window.addEventListener("keydown", this.handleKeydown);
    this.$root.$on("qs:open-news", this.onOpenFromAI);
    this.startNewsPolling();
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeydown);
    this.$root.$off("qs:open-news", this.onOpenFromAI);
    this.stopNewsPolling();
  },

  methods: {
    onClientShowMacro() {
      this.showMacro = !this.showMacro;
      this.onCategoriesChanged();
    },
    onClientShowIndexes() {
      this.showIndexes = !this.showIndexes;
      this.onCategoriesChanged();
    },
    onClientShowIntRates() {
      this.showIntRates = !this.showIntRates;
      this.onCategoriesChanged();
    },
    // onClientEn() {
    //   this.languajeEn = !this.languajeEn;
    //   this.onCategoriesChanged();
    // },
    handleKeydown(event) {
      if (event.key === "Escape" && this.selectedNews) {
        this.closeNews();
      }
    },
    formatTag(tag) {
      const prefixes = [
        "group_",
        "fx_",
        "fx_group_",
        "geo_",
        "index_",
        "int_rate_",
        "season_",
      ];
      const matchedPrefix = prefixes.find((prefix) => tag.startsWith(prefix));
      if (!matchedPrefix) {
        return tag.replaceAll("_", " ");
      }
      const prefixText = matchedPrefix
        .slice(0, -1) // remove trailing _
        .replaceAll("_", " ");
      const rest = tag.slice(matchedPrefix.length).replaceAll("_", " ");
      return `${prefixText}: ${rest}`;
    },
    renderMarkdown(content) {
      return md.render(content || "");
    },
    loadInitialValues() {
      const saved = this.$store.getters["user_preferences/newsPreferences"];

      const commodityValues =
        Array.isArray(saved?.commodities) && saved.commodities.length > 0
          ? saved.commodities
          : DEFAULT_COMMODITY;
      this.selectedCommodities = COMMODITIES.filter((o) =>
        commodityValues.includes(o.value),
      );

      const currencyValues =
        Array.isArray(saved?.currencies) && saved.currencies.length > 0
          ? saved.currencies
          : DEFAULT_CURRENCY;
      this.selectedCurrencies = CURRENCIES.filter((o) =>
        currencyValues.includes(o.value),
      );

      this.showMacro = saved?.show_macro ?? false;
      this.showIndexes = saved?.show_indexes ?? false;
      this.showIntRates = saved?.show_int_rates ?? false;
    },
    removeCommodity(category) {
      if (category == null || this.selectedCommodities.length === 1) {
        this.selectedCommodities = [];
        this.onCategoriesChanged();
        return;
      }
      this.selectedCommodities = this.selectedCommodities.filter(
        (s) => s.value !== category.value,
      );
      this.onCategoriesChanged();
    },
    removeCurrency(category) {
      if (category == null || this.selectedCurrencies.length === 1) {
        this.selectedCurrencies = [];
        this.onCategoriesChanged();
        return;
      }
      this.selectedCurrencies = this.selectedCurrencies.filter(
        (s) => s.value !== category.value,
      );
      this.onCategoriesChanged();
    },

    onCategoriesChanged() {
      this.showFetchButton = true;
    },
    onFetchButton() {
      this.saveCategories();
      this.fetchNews();
      this.showFetchButton = false;
    },

    saveCategories() {
      this.$store.dispatch("user_preferences/updateNewsPreferences", {
        commodities: this.selectedCommodityValues,
        currencies: this.selectedCurrencyValues,
        show_macro: this.showMacro,
        show_indexes: this.showIndexes,
        show_int_rates: this.showIntRates,
      });
      try {
        saveUserPreferences(this);
      } catch (error) {
        console.error("Error saving news preferences", error);
      }
    },

    fetchNews() {
      this.newsOffset = 0;
      this.newsTotal = 0;
      getNews(this, {
        fieldName: "newsList",
        fieldShowLoadingName: "isLoading",
        fieldErrorName: "errorMsg",
        fieldTotalName: "newsTotal",
        commodities: this.selectedCommodityValues,
        currencies: this.selectedCurrencyValues,
        macro: this.showMacro,
        indexes: this.showIndexes,
        interest_rates: this.showIntRates,
      });
    },

    loadMoreNews() {
      this.newsOffset += 100;
      getNews(this, {
        fieldName: "newsList",
        fieldShowLoadingName: "isLoadingMore",
        fieldErrorName: "errorMsg",
        fieldTotalName: "newsTotal",
        commodities: this.selectedCommodityValues,
        currencies: this.selectedCurrencyValues,
        macro: this.showMacro,
        indexes: this.showIndexes,
        interest_rates: this.showIntRates,
        offset: this.newsOffset,
        append: true,
      });
    },

    startNewsPolling() {
      this.newsPollTimer = setInterval(() => {
        this.fetchNewsInBackground();
      }, 10 * 60 * 1000); // Poll every 10 minutes
    },

    stopNewsPolling() {
      if (this.newsPollTimer) {
        clearInterval(this.newsPollTimer);
        this.newsPollTimer = null;
      }
    },

    fetchNewsInBackground() {
      if (this.showFetchButton) return;
      getNews(this, {
        fieldName: "backgroundNewsBuffer",
        fieldShowLoadingName: "isBackgroundRefreshing",
        fieldErrorName: "backgroundErrorMsg",
        fieldTotalName: "newsTotal",
        commodities: this.selectedCommodityValues,
        currencies: this.selectedCurrencyValues,
        macro: this.showMacro,
        indexes: this.showIndexes,
        interest_rates: this.showIntRates,
      }).then(() => this.mergeBackgroundNews());
    },

    mergeBackgroundNews() {
      const incoming = this.backgroundNewsBuffer || [];
      this.backgroundNewsBuffer = [];
      if (incoming.length === 0) return;
      const existingUrls = new Set(this.newsList.map((n) => n.url));
      const newOnes = incoming.filter((n) => !existingUrls.has(n.url));
      if (newOnes.length > 0) {
        this.newsList = [...newOnes, ...this.newsList];
      }
    },

    onNewsScroll() {
      const el = this.$refs.newsBody;
      if (!el) return;
      const threshold = 200;
      const nearBottom =
        el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;
      if (
        nearBottom &&
        !this.isLoading &&
        !this.isLoadingMore &&
        this.newsList.length < this.newsTotal
      ) {
        this.loadMoreNews();
      }
    },

    getImage(news, idx) {
      return getImageForNews(news, this.selectedCommodities, idx);
    },

    getItemTags(news) {
      return getItemTags(news);
    },

    getAllTags(news) {
      return getAllTags(news);
    },

    timeAgo(dateStr) {
      return timeAgo(dateStr);
    },
    getNewsHighlight(dateStr) {
      return getNewsHighlight(dateStr);
    },

    onImgError(event, idx) {
      const fallback = getFallbackImageByCategories(
        this.selectedCommodities,
        idx,
      );
      if (event.target.src !== fallback) {
        event.target.src = fallback;
      } else {
        event.target.style.display = "none";
      }
    },

    onOpenFromAI(url) {
      const found = this.newsList.find((news) => news.url === url);
      if (found) {
        this.selectedNews = found;
      } else {
        window.open(url, "_blank", "noopener,noreferrer");
      }
    },
    openNews(news) {
      this.selectedNews = news;
    },

    closeNews() {
      this.selectedNews = null;
    },
  },
};
</script>

<style scoped src="@/assets/css/NewsWidget.css" />
